exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spanQandABijlage .uploader-file-actions{display:none}.spanQandABijlage .upload-success{background-color:transparent}.spanQandABijlage .uploader-file-name{text-indent:0;white-space:normal;word-break:break-all}.spanQandABijlage .uploader-file-icon{display:none}.spanQandABijlage .uploader-file{height:auto;line-height:inherit;border-bottom:0;border-left:0}.spanQandABijlage .divIconPaperclip,.spanQandABijlage .xvuploadclass{display:inline-block;padding-top:10px;padding-bottom:15px}.spanQandABijlage .iconpaperclip{margin-bottom:2px}.spanQandABijlage .uploader-drop,.spanQandABijlage .uploader-file-progress{display:none}", ""]);

// exports
